import { ID } from './id';

export enum PriceInterval {
  Year = 'year',
  Month = 'month',
  Lifetime = 'lifetime',
}

export type Price = {
  id: ID;
  currency: string;
  interval: PriceInterval;
  amountInCents: number;
  saving: number;
  savingPercentage: number;
  expires?: string;
  coupon?: {
    id: ID;
    name: string;
    saving: number;
    amount?: number | null;
    percentage?: number | null;
  } | null;
};

export type Discount = {
  id: ID;
  applicableIntervals: PriceInterval[];
  percentage?: number;
  amount?: number;
};

export const currencySignMap: Record<string, string> = {
  aud: '$',
  brl: 'R$',
  cad: '$',
  chf: 'CHF',
  dkk: 'kr',
  eur: '€',
  gbp: '£',
  inr: '₹',
  jpy: '¥',
  nok: 'kr',
  nzd: '$',
  pln: 'zł',
  sek: 'kr',
  usd: '$',
};
